import React, { Component } from "react";
import { connect } from "react-redux";
import { logout } from "../../actions";
import { withRouter } from "react-router-dom";
const queryString = require("query-string");

class Logout extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.logout();
    if (this.props.location.search) {
        const parsed = queryString.parse(this.props.location.search);
        // If there is any error when login by signicat
        if (parsed.state && parsed.state === "SIGNICAT_ERROR") {
            this.props.history.push("/no-open-cases");
            return;
        } 
    }
    this.props.history.push("/");
  }
  render() {
    return null;
  }
}

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(logout())
});

export default withRouter(connect(null, mapDispatchToProps)(Logout));


// WEBPACK FOOTER //
// ./src/containers/Logout/Logout.js